import MyTabbedLayout from "../mui/TabbedLayout";
import Comission from "./Comission";
import PendingPayments from "./PendingPayments";

export default function FinanceManagement() {


        
    return (<div>
        <h1 className="px-4 py-2 text-white mt-2 bg-red-500 rounded-md w-60  text-[20px]">
            Finance Management
        </h1>
        <div className="w-full bg-white mt-6 rounded-lg">
            <MyTabbedLayout
                defaultSelection={
                    0
                }
                onSelection={(value) => {
                 
                }}
                tabs={[
                    {
                        title: "Comissions",
                        element: (
                            <Comission/>
                        )
                    },
                    {
                        title: "Pending Payments",
                        element: (
                            <PendingPayments/>
                        )
                    }
                ]} />

        </div>
    </div>)
}